<template>
  <div>
    <v-list-item @click.stop="onDialog" link v-if="!hideTitle">
      <v-list-item-title>来社入力</v-list-item-title>
    </v-list-item>
    <v-dialog v-model="dialogForm" persistent max-width="800px">
      <v-card>
        <v-form ref="form">
          <v-card-title class="justify-space-between">
            <span class="headline">来社入力</span>
            <v-btn v-if="customer && typeSubmit === 'update'" color="info" class="info ms-4" @click="switchForm(formTypes.TYPE_FORM.INPUT_PARTNER_SELECTION)">お相手選びへの変更</v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="container grid-list-md">
            <v-layout wrap>
              <v-flex xs6>
                <v-select v-model="dataHistory.kind" :items="kinds" :rules="rules.kind" item-text="text"
                  item-value="value" label="取組区分" @change="changeKind"></v-select>
              </v-flex>
              <v-flex xs6 class="d-flex align-center">
                <v-checkbox v-model="dataHistory.is_online" label="オンライン"></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFormatted" :rules="rules.target_date" readonly :label="dataHistory.kind == 101 ? '契約日' : '日付'"
                      append-icon="mdi-calendar" persistent-hint v-bind="attrs" v-on="on" width="120px">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dataHistory.target_date"
                    :day-format="(target_date) => new Date(target_date).getDate()" no-title></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 v-if="dataHistory.kind != kindContract && dataHistory.kind != kindShiftContract">
                <v-select v-model="dataHistory.status" :items="status" :rules="rules.status" item-text="text"
                  item-value="value" label="状態"></v-select>
              </v-flex>
              <v-flex xs6>
                <v-dialog ref="dialog1" v-model="timePick['target_time']" :return-value.sync="dataHistory.target_time"
                  persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataHistory.target_time" :rules="rules.target_time" label="実施時刻" readonly
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time']" v-model="dataHistory.target_time" full-width scrollable
                    format="24hr" @change="changeTimeStart">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time'] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="saveTimeStart">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6>
                <v-dialog ref="dialog2" v-model="timePick['target_time_end ']"
                  :return-value.sync="dataHistory.target_time_end" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataHistory.target_time_end" :rules="rules.target_time_end" label="終了時刻"
                      readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time_end ']" v-model="dataHistory.target_time_end"
                    :min="minTime" full-width scrollable format="24hr">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time_end '] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog2.save(dataHistory.target_time_end)">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6 v-if="dataHistory.kind != kindVals.ADVISE && dataHistory.kind != kindVals.USAGE_PROHIBITED && dataHistory.kind != kindVals.WOMAN_FIRST">
                <v-text-field v-model="phone" :rules="rules.phone" @blur="apiPhone($event)" ref="phone" type="text"
                  label="携帯番号" :readonly="customerFromHistory"></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="dataHistory.kind != kindVals.ADVISE && dataHistory.kind != kindVals.USAGE_PROHIBITED && dataHistory.kind != kindVals.WOMAN_FIRST">
                <v-autocomplete v-model="family_name" :rules="rules.family_name" label="会員名"
                  @keydown="focusCustomerName" @update:search-input="debounce" @input="inputCustomerName"
                  :items="itemFamilyNames" @blur="blurName" :readonly="customerFromHistory"></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-select v-model="dataHistory.counselor_id"
                  :items="((customer && customer.shop_id !== null) || dataHistory.kind == kindVals.ADVISE) ? validCounselors : counselors"
                  :rules="rules.counselor"
                  item-text="name" item-value="id" label="実施担当"
                  @change="onCounselorSelected">
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': !(item.resignation_date == null || moment(item.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))}">
                        <v-list-item-title>
                          {{ item.name }}
                        </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs6>
                <v-select v-model="dataHistory.booth_no_id" :items="validBoothNos" :rules="dataHistory.kind !== kindVals.USAGE_PROHIBITED ? rules.boothNo : []"
                  item-text="booth_no" item-value="id" label="ブース№"></v-select>
              </v-flex>
              <v-flex xs6 v-if="kindPattern1.includes(dataHistory.kind)" class="d-flex align-center">
                <v-checkbox v-model="dataHistory.option.verTel" label="AD差し戻し済"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="kindPattern3.includes(dataHistory.kind)" class="d-flex align-center">
                <v-checkbox v-model="dataHistory.option.verTel" label="前日確認済"></v-checkbox>
              </v-flex>
              <template v-if="dataHistory.kind == kindVals.AHEAD_SHIFT_CO || dataHistory.kind == kindVals.THIS_SHIFT_CO">
                <v-flex xs6>
                  <v-select v-model="dataHistory.shift_negotiations" :items="statusShiftNegotiations" :rules="rules.shift_negotiations" item-text="text"
                    item-value="value" label="シフト交渉"></v-select>
                </v-flex>
              </template>
              <v-flex xs12>
                <v-textarea 
                  label="メモ" 
                  v-model="dataHistory.note" 
                  :rules="rules.note"
                  :rows="3"
                  @input="onMemoInput"
                  @click="onMemoClick"
                  ref="memoTextarea"
                  class="memo-textarea"
                > 
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn width="132" class="info" @click="checkHistory">登録</v-btn>
            <v-btn width="132" class="secondary" @click="closeDialog">戻る</v-btn>
            <v-btn width="132" class="error" @click="clearDataDialog" v-if="typeSubmit == 'update'">削除</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    
    <MemoEditorDialog
      :visible.sync="memoDialog"
      v-model="dataHistory.note"
      :rules="rules.note"
    />
  </div>
</template>

<script>
import { required, inArray, phone, digits, date, max, isSelectedCounselor } from '@/utilities/validation.js';
import CUSTOMER from "@/consts/customer.js";
import moment from "moment";
import constants from '@/consts/constants.js'
import store from '@/store'
import Swal from 'sweetalert2';
import MemoEditorDialog from '@/components/common/MemoEditorDialog.vue'

export default {
  name: "CompanyVisit",
  components: { MemoEditorDialog },
  props: ["date", "dialogCV", 'boothNos', 'counselors', 'shop_id', 'historyData', 'hideTitle', 'valueKindForForm', 'valueKindForShift', 'customer', 'isLedgerScreen', 'isOnlineShop'],
  data: function () {
    const kinds = CUSTOMER.KINDS_FOR_COMPANY_VISIT.LIST;
    const kindVals = CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL;
    const statusPlan = CUSTOMER.STATUS.getValue('予定')
    const aHeadShiftCO = kindVals.AHEAD_SHIFT_CO
    const thisShiftCO = kindVals.THIS_SHIFT_CO

    return {
      // validate
      rules: {
        kind: [
          (v) => required(v),
          (v) => inArray(v, kinds.map(item => item.value)),
        ],
        target_date: [
          (v) => required(v),
          (v) => date(v),
        ],
        target_time: [
          (v) => required(v),
        ],
        target_time_end: [
          (v) => required(v),
        ],
        phone: [
          (v) => required(v),
          (v) => phone(v),
          (v) => digits(v, 13),
        ],
        family_name: [
          (v) => required(v),
        ],
        boothNo: [
          () => isSelectedCounselor(this.dataHistory.counselor_id),
          (v) => required(v),
          (v) => inArray(v, this.validBoothNos.map(item => item.id)),
        ],
        counselor: [
          (v) => required(v),
        ],
        note: [
          (v) => max(v, 1000),
        ],
      },

      dataHistory: {
        kind: '',
        target_date: this.date,
        status: statusPlan,
        target_time: "",
        target_time_end: "",
        customer_id: null,
        booth_no_id: "",
        counselor_id: "",
        note: "",
        option: { verTel: false },
        type: constants.TYPE_FORM.COMPANY_VISIT_INPUT,
        shift_negotiations: null,
        is_online: false,
      },
      status: CUSTOMER.STATUS.LIST,
      statusShiftNegotiations: CUSTOMER.STATUS_SHIFT_NEGOTIATIONS.LIST,
      family_name: "",
      family_name_old: "",
      kinds,
      phone: "",
      timePick: [],
      customers: '',
      itemFamilyNames: [],
      isFamilyName: false,

      dialogForm: false,
      kindVals,
      moment: moment,
      typeSubmit: null,
      addTimeWithKind: 0,
      minTime: null,
      timer: null,
      isValueForm: [1000, 121, 123, 14, 12, 401, 102, 101, 1002, 1016],
      customerFromHistory: false,
      kindPattern1: [101],
      kindPattern2: [14, 12, 401, 102, 1000, 1002, 1016],
      kindPattern3: [121, 123],
      kindContract: kindVals.CONTRACT,
      kindShiftContract: kindVals.SHIFT_CONTRACT,
      statusPlan,
      kindHideStatus: [kindVals.CONTRACT, kindVals.SHIFT_CONTRACT],
      aHeadShiftCO,
      thisShiftCO,
      contractDate: null,
      targetDate: this.date,
      validBoothNos: [],
      validCounselors: [],
      formTypes: constants,
      // memo modal state
      isMemoFocused: false,
      memoDialog: false,
      memoContent: '',
    }
  },
  created: function () {
    if (this.valueKindForShift != undefined && this.valueKindForShift != null) {
      this.dataHistory.kind = ""
      this.kinds = [
        { value: CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.AHEAD_SHIFT_CO, text: CUSTOMER.KINDS_FOR_COMPANY_VISIT.NAME.AHEAD_SHIFT_CO },
        { value: CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.THIS_SHIFT_CO, text: CUSTOMER.KINDS_FOR_COMPANY_VISIT.NAME.THIS_SHIFT_CO },
      ]
    }
  },
  computed: {
    computedDateFormatted() {
      const target_date = this.dataHistory.target_date ? this.formatDate(this.dataHistory.target_date) : this.formatDate(this.date)
      return target_date
    },
  },

  watch: {
    'dataHistory.target_date': function () {
      this.getKindForFormShift()
    },
    phone: function (newPhone) {
      if (newPhone) {
        const phone = newPhone.replace(/\D/g, '')
        const firstBlockPhone = phone.substring(0, 3)
        const secondBlockPhone = phone.substring(3, 7)
        const thirdBlockPhone = phone.substring(7)

        let formatPhone = `${firstBlockPhone}`;
        if (secondBlockPhone.length > 0) {
          formatPhone += `-${secondBlockPhone}`;
        }
        if (thirdBlockPhone.length > 0) {
          formatPhone += `-${thirdBlockPhone}`;
        }
        this.phone = formatPhone;
      }
    },
    dialogCV: function (newDialog) {
      this.dialogForm = newDialog
      this.validCounselors = this.counselors
      this.validBoothNos = []
    },
    historyData: function (newDataHistory) {
      if (this.valueKindForForm.length == 0) {
        this.dataHistory.kind = newDataHistory.kind
        this.dataHistory.target_date = this.formatDateSlash(newDataHistory.target_date)
        this.dataHistory.target_time = newDataHistory.target_time
        this.dataHistory.target_time_end = newDataHistory.target_time_end
        this.dataHistory.customer_id = newDataHistory.customer_id
        this.dataHistory.booth_no_id = newDataHistory.booth_no_id
        this.dataHistory.counselor_id = newDataHistory.counselor_id
        this.dataHistory.note = newDataHistory.note
        this.dataHistory.option = newDataHistory.option
        this.phone = newDataHistory.phone
        this.family_name = newDataHistory.family_name + newDataHistory.given_name
        this.family_name_old = this.family_name
        this.itemFamilyNames = [this.family_name]
        this.dataHistory.shift_negotiations = newDataHistory.shift_negotiations
        this.dataHistory.is_online = newDataHistory.is_online == 1
        this.typeSubmit = 'update'
        // this.changeKind()
        this.getTimeAddWithKind(this.dataHistory.kind)
        this.validBoothNos = this.boothNos
      }
      this.dataHistory.status = newDataHistory.status
      if (this.dataHistory.kind == this.kindVals.ADVISE) {
        this.getCOAndAds()
      }
    },
    valueKindForForm: function (newValueKindForForm) {
      if (newValueKindForForm) {
        if (this.customer.id != CUSTOMER.NOT_MEMBER_CUSTOMER && this.customer.id != CUSTOMER.MEMBER_CONNECT) {
          this.customerFromHistory = true
          this.family_name = this.customer.family_name + this.customer.given_name
          this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
          this.phone = this.customer.phone_number
        } else {
          this.family_name = ''
          this.phone = ''
        }
        this.dataHistory = {
          kind: newValueKindForForm,
          target_date: this.date,
          status: this.statusPlan,
          target_time: "",
          target_time_end: "",
          customer_id: null,
          booth_no_id: "",
          counselor_id: "",
          note: "",
          option: { verTel: false },
          type: constants.TYPE_FORM.COMPANY_VISIT_INPUT,
          is_online: this.isOnlineShop ? true : false,
        }
        this.typeSubmit = ''
        this.changeKind()
        if (this.isValueForm.includes(newValueKindForForm) && this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }
    },
    date: function (newDate) {
      if (newDate) {
        this.dataHistory.target_date = newDate
      }
    },
  },

  methods: {
    blurName() {
      this.itemFamilyNames = [this.family_name_old]
      this.family_name = this.family_name_old
      this.isFamilyName = false;
    },
    async debounce(e, timeout = 300) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.searchInputCustomerName(e) }, timeout);
    },
    focusCustomerName() {
      this.isFamilyName = true;
    },
    async searchInputCustomerName(e) {
      if (!this.isFamilyName || e == null || e == '') {
        return
      }

      const url = '/api/v1/customer/by-name/' + e
      const response = await this.$axios.get(url)
      this.customers = response.data.customers
      this.itemFamilyNames = this.customers.map(item => {
        return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
      })
    },
    async inputCustomerName(e) {
      if (e == null) {
        return
      }

      const customers = await this.customers.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

      if (Object.keys(customers).length > 0) {
        this.itemFamilyNames = await [customers.family_name + customers.given_name]
        this.family_name = await customers.family_name + customers.given_name
        this.family_name_old = await customers.family_name + customers.given_name
        this.phone = await customers.phone_number;
        this.phoneOld = await customers.phone_number
        this.genderCustomer = await customers.gender;
        this.dataHistory.customer_id = await customers.id
        this.contractDate = customers.contract_date
        this.getKindForFormShift()
        if (this.customer && this.customer.shop_id !== null) {
          this.getCounselorByCustomerShopId(this.dataHistory.customer_id)
          this.dataHistory.counselor_id = ''
          this.validBoothNos = []
        }
      }

      this.isFamilyName = false;
    },
    filterDataBody(data) {
      return Object.entries(data)
        .reduce((items, [key, value]) => {
          if (value !== null) {
            items[key] = value;
          }
          return items;
        }, {});
    },
    onDialog() {
      this.$emit('closeMenu')
      this.dialogForm = true
    },
    closeDialog() {
      this.dialogForm = false
      this.clearDataDialog()
      this.$emit('closeMenu')
      this.$emit('closeDialogCV')
    },
    clearDataDialog() {
      if (this.typeSubmit == 'update') {
        if (this.valueKindForForm.length == 0) {
          this.dataHistory.kind = this.historyData.kind
          this.dataHistory.target_date = this.formatDateSlash(this.historyData.target_date)
          this.dataHistory.status = '予定'
          this.dataHistory.target_time = this.historyData.target_time
          this.dataHistory.target_time_end = this.historyData.target_time_end
          this.dataHistory.customer_id = this.historyData.customer_id
          this.dataHistory.booth_no_id = this.historyData.booth_no_id
          this.dataHistory.counselor_id = this.historyData.counselor_id
          this.dataHistory.note = this.historyData.note
          this.dataHistory.option = this.historyData.option
          this.phone = this.historyData.phone
          this.family_name = this.historyData.family_name + this.historyData.given_name
          this.itemFamilyNames = [this.family_name]
          this.dataHistory.shift_negotiations = this.historyData.shift_negotiations
          this.changeKind()
        }
      } else {
        this.family_name = ""
        this.phone = null
        this.dataHistory = {
          kind: "",
          target_date: this.date,
          status: this.statusPlan,
          target_time: "",
          target_time_end: "",
          customer_id: null,
          booth_no_id: "",
          counselor_id: "",
          note: "",
          option: { verTel: false },
          type: constants.TYPE_FORM.COMPANY_VISIT_INPUT,
          is_online: this.isOnlineShop ? true : false,
        }
        if (this.customerFromHistory) {
          this.dataHistory.kind = this.valueKindForForm
          this.family_name = this.customer.family_name + this.customer.given_name
          this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
          this.phone = this.customer.phone_number
        }
        this.validBoothNos = []
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.$emit('closeMenu')
    },
    formatDateSlash(date) {
      if (!date) return null

      const [year, month, day] = date.split('/')
      return `${year}-${month}-${day}`
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },

    checkHistory() {
      const validate = this.$refs.form.validate()
      if (validate == false) {
        return
      }
      let dataHistory = this.dataHistory
      if (this.historyData?.id) {
        dataHistory.id = this.historyData.id
      }
      this.$axios
        .post("/api/v1/customer/check-history", { dataHistory: dataHistory })
        .then((response) => {
          if (!response.data.canCreate) {
            let  errorMsg = '以下の予定と重複していますが、登録してよろしいですか？';
            if (response.data.conflictingAppointmentRes) {
              const { kind, targetTime, targetTimeEnd, counselorName, boothNoName, customerName } = response.data.conflictingAppointmentRes;
              errorMsg += `<p style="font-weight: bold;">${CUSTOMER.EXEC_KIND.getName(kind)}</p>`;
              errorMsg += `<p>時間：${targetTime.slice(0, -3)}〜${targetTimeEnd.slice(0, -3)}</p>`;
              errorMsg += `<p>${customerName}</p>`;
              errorMsg += `<p>担当：${counselorName}</p>`;
              errorMsg += `<p>ブース：${boothNoName || '--'}</p>`;
            }

            Swal.fire({
              html: `<div style="text-align: left; color: #000000de; font-size: 14px; font-family: 'Roboto';">${errorMsg}</div>`,
              confirmButtonText: `<span style="font-size: 14px;">OK</span>`,
              confirmButtonColor: "#1e88e5",
              color: '#ffffff',
              showCancelButton: true,
              cancelButtonText: `<span style="font-size: 14px;">Cancel</span>`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.submitVisitForm()
              }
            });
          } else {
            this.submitVisitForm()
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    submitVisitForm() {
      const validate = this.$refs.form.validate()
      if (validate == false) {
        return
      }
      if (this.customerFromHistory) {
        this.dataHistory.customer_id = this.customer.id
      }
      //if (this.dataHistory.kind == this.kindContract || this.dataHistory.kind == this.kindShiftContract) {
      //  this.dataHistory.status = 0
      //}

      if (this.kindPattern2.includes(this.dataHistory.kind)) {
        this.dataHistory.option.verTel = false
      }
      if (this.dataHistory.booth_no_id === '' && this.dataHistory.kind === this.kindVals.USAGE_PROHIBITED) {
        this.dataHistory.booth_no_id = null
      }
      const dataHistory = this.filterDataBody(this.dataHistory)
      if (this.typeSubmit == 'update') {
        this.$axios.put(`/api/v1/customer/${this.dataHistory.customer_id}/history/${constants.TYPE_FORM.COMPANY_VISIT_INPUT}`, { historyId: this.historyData.id, historyData: dataHistory })
          .then(() => {
            this.$emit('refreshListHistory')
            this.$emit('closeDialogCV')
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      } else {
        this.$axios.post("/api/v1/customer/history", { dataHistory })
          .then(() => {
            this.dialogForm = false
            this.clearDataDialog()
            this.$emit('refreshCalendar')
            if (this.valueKindForForm) {
              this.$emit('refreshListHistory')
              this.$emit('closeDialogCV')
            }
            if (this.isLedgerScreen) {
              this.$emit('refreshLedgerData')
            }
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      }
    },

    apiPhone(e) {
      this.isFamilyName = false;

      const currentUserLoginShopId = store.state.user.shop_id
      const validate = this.$refs.phone.validate()
      if (validate == false) {
        this.phoneOld = e.target.value
        this.family_name = ''
        this.family_name_old = ''
        this.itemFamilyNames = []
        if (this.valueKindForShift != undefined && this.valueKindForShift != null) {
          this.dataHistory.kind = ''
        }
        if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
          this.dataHistory.counselor_id = ''
          this.validCounselors = []
          this.validBoothNos = []
        }
        return
      }
      this.$axios
        .get("/api/v1/customer/phone_number/" + e.target.value)
        .then((response) => {
          const customer = response.data.customer
          if (customer.id != undefined) {
            this.family_name = customer.family_name + customer.given_name
            this.family_name_old = this.family_name;
            this.itemFamilyNames = [this.family_name]
            this.dataHistory.customer_id = customer.id || CUSTOMER.NOT_MEMBER_CUSTOMER
            this.contractDate = customer.contract_date
            this.getKindForFormShift()
            if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
              this.dataHistory.counselor_id = ''
              this.getCO(customer)
              this.validBoothNos = []
            }
          } else {
            alert('対象者が存在しません')
            this.phone = ''
            this.family_name = ''
            this.itemFamilyNames = []
            if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
              this.dataHistory.counselor_id = ''
              this.validCounselors = []
              this.validBoothNos = []
            }
            return false;
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    changeKind() {
      if (this.dataHistory.kind != this.kindContract || this.dataHistory.kind != this.kindShiftContract) {
        this.dataHistory.status = this.statusPlan
      }
      this.$axios
        .get("/api/v1/date-setting/" + this.dataHistory.kind)
        .then((response) => {
          this.addTimeWithKind = response.data.kind.date_add
          if (this.dataHistory.target_time != "") {
            const startAt = moment(this.dataHistory.target_time, 'HH:mm')
            this.dataHistory.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });

      if (this.dataHistory.kind == this.kindVals.ADVISE) {
        this.getCOAndAds()
      }
    },
    getTimeAddWithKind(kind) {
      if (kind) {
        this.$axios
          .get("/api/v1/date-setting/" + kind)
          .then((response) => {
            this.addTimeWithKind = response.data.kind.date_add
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      }
    },
    changeTimeStart() {
      const startAt = moment(this.dataHistory.target_time, 'HH:mm')
      this.dataHistory.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
      this.minTime = moment(this.dataHistory.target_time, 'HH:mm').add(30, 'minutes').format('HH:mm')
    },
    saveTimeStart() {
      this.changeTimeStart(this.dataHistory.target_time)
      this.$refs.dialog1.save(this.dataHistory.target_time > this.dataHistory.target_time_end ? this.dataHistory.target_time_end : this.dataHistory.target_time)
    },
    getKindForFormShift() {
      if (this.valueKindForShift != undefined && this.valueKindForShift != null) {
        if (moment(this.contractDate).add(1, 'years').format("yyyy-MM") == moment(this.dataHistory.target_date).format("yyyy-MM")) {
          this.dataHistory.kind = this.thisShiftCO
        }

        if (moment(this.contractDate).add(1, 'years').add(1, 'months').format("yyyy-MM") == moment(this.dataHistory.target_date).format("yyyy-MM")) {
          this.dataHistory.kind = this.aHeadShiftCO

        }
        if (this.dataHistory.kind) {
          this.changeKind()
        }
      }
    },
    async onCounselorSelected() {
      const validCounselors = ((this.customer && this.customer.shop_id !== null) || this.dataHistory.kind == this.kindVals.ADVISE) ? this.validCounselors : this.counselors
      const counselorSelected = validCounselors.find(counselor => counselor.id === this.dataHistory.counselor_id)
      await this.$axios.get(`/api/v1/booth_no/shop/${counselorSelected.shop_id}`)
        .then((response) => {
          this.validBoothNos = response.data.booth_nos;
          if (response.data.booth_nos.length > 0 && response.data?.booth_nos[0]?.shop_id != counselorSelected.shop_id) {
            this.dataHistory.booth_no_id = "";
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    getCO(customer) {
      this.$axios
        .get(`/api/v1/user/counselors?shop_id=${customer.shop_id}`)
        .then((response) => {
          this.validCounselors = response.data.counselors
        })
        .catch((error) => {
          console.log("Error : " + error)
        })
    },
    async getCOAndAds() {
      await this.$axios
        .get(`/api/v1/user/counselor-ads?shop_id=${this.shop_id}`)
        .then((response) => {
          this.validCounselors = response.data.counselors
        })
        .catch((error) => {
          console.log("Error : " + error)
        })
    },
    getCounselorByCustomerShopId(customerId) {
      if (customerId) {
        this.$axios
          .get(`/api/v1/customer/${customerId}`)
          .then((response) => {
            const customer = response.data.customer
            if (customer.id != undefined) {
              this.getCO(customer)
            } else {
              alert('対象者が存在しません')
              this.validCounselors = []
              this.validBoothNos = []
              return false
            }
          })
          .catch((error) => {
            console.log("Error : " + error)
          })
      }
    },
    switchForm(formType) {
      this.$emit('switchForm', formType)
    },
    openMemoModal() {
      if (this.memoDialog) return;
      this.memoDialog = true;
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
      });
    },
    checkMemoContentAndOpenModal(content, maxLines = 3) {
      if (!content || !content.trim()) return;
      
      const explicitLineCount = content.split(/\r?\n/).length;
      
      if (explicitLineCount > maxLines) {
        this.openMemoModal();
        return;
      }
      
      this.$nextTick(() => {
        const textarea = this.$refs.memoTextarea && this.$refs.memoTextarea.$el
          ? this.$refs.memoTextarea.$el.querySelector('textarea')
          : null;
        
        if (textarea) {
          const originalHeight = textarea.style.height;
          textarea.style.height = 'auto';
          
          const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight) || 24;
          const visualLines = Math.ceil(textarea.scrollHeight / lineHeight);
          
          textarea.style.height = originalHeight;
          
          if (visualLines > maxLines) {
            this.openMemoModal();
          }
        }
      });
    },
    onMemoInput(val) {
      const content = typeof val === 'string' ? val : (this.dataHistory.note || '');
      this.checkMemoContentAndOpenModal(content, 3);
    },
    onMemoClick() {
      const content = this.dataHistory.note || '';
      this.checkMemoContentAndOpenModal(content, 3);
    },
  }
};
</script>

<style scoped>
.container.grid-list-md .layout .flex {
  padding: 4px 12px;
}

/* Clickable textarea styling */
.clickable-textarea {
  cursor: pointer;
}

.memo-modal-textarea ::v-deep .v-text-field__slot textarea {
  min-height: 120px !important;
  max-height: unset !important;
  line-height: 24px !important;
  padding: 12px !important;
  font-size: 14px !important;
  overflow-y: auto !important;
  resize: vertical !important;
}
</style>
